<template>
    <jt-form
        :alertType="alert.type"
        :alertShow="alert.show"
        :alertMessage="alert.message"
        v-on:create="update()"
        v-on:closeAlert="closeAlert()"
        v-on:clear="clear()"
        title="Novo Grupo"
    >
        <b-overlay :show="showOverlay" rounded="sm">
            <div class="form-row">
                <div class="col-md-6">
                    <b-form-group
                        label="Descrição (Nome do grupo)"
                    >
                        <b-form-input
                            type="text"
                            placeholder="Descrição do grupo"
                            v-model="form.descricao"
                            size="sm"
                        />
                        <small v-if="!$v.form.descricao.required" >Campo requerido</small>
                        <small v-if="!$v.form.descricao.minLength" >A descrição esta muito curta.</small>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group
                        label="Grupo"
                    >
                        <v-select 
                            :options="grupos" 
                            v-model="form.grupo"
                            :searchable="true" 
                            textProp="descricao"
                            valueProp="id"
                            labelNotFound="Nenhum valor encontrado."
                        />
                        <small v-if="!$v.form.grupo.required" >Campo requerido</small>
                    </b-form-group>
                </div>
            </div>
        </b-overlay>
    </jt-form>
</template>
<script>
    import jtForm from '@/components/form.vue'
    import VSelect from '@alfsnd/vue-bootstrap-select'
    import { 
        required, 
        minLength
    } from 'vuelidate/lib/validators'
    export default {
        name: 'editarSubGrupoView',
        components: {
            jtForm,
            VSelect
        },

        data(){
            return {
                showOverlay: false,
                form: {
                    descricao: null,
                    grupo: null,
                },

                alert: {
                    type: 'alert-warning',
                    message: '',
                    show: false
                },

                grupos: []
            }
        },

        validations: {
            form: {
                descricao: {
                    required,
                    minLength: minLength(8)
                },

                grupo: {
                    required
                },
            }
        },

        computed: {
            getToken(){
                return this.$store.getters.getToken
            },

            id(){
                return this.$route.params.id
            }
        },

        methods: {
            buscarDados : function(){
                this.showOverlay = true
                // eslint-disable-next-line
                fetch(server + 'crud/sub-grupo/' + this.id, {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data == true){
                            this.form = {
                                descricao: responseJSON.response[0].descricao,
                                grupo: responseJSON.response[0].grupo,
                            } 
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
                    .finally(() => {
                        this.showOverlay = false
                    })
            },

            buscarGrupos: function(){
                this.showOverlay = true
                fetch(server + 'crud/grupo', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => {
                        if(response.status == 200){
                            response.json()
                                .then(data => {
                                    if(data.data){
                                        this.grupos = data.response
                                    }else{
                                        console.error('Error exception', '=>', data.message)
                                    }
                                })
                                .catch(error => {
                                    console.error('Error exception', '=>', error.message)
                                })
                        }else{
                            console.error('Error exception', '=>', response.statusText)
                        }
                    })
                    .catch(error => {
                        console.error('Error exception', '=>', error.message)
                    })
                    .finally(() => {
                        this.showOverlay = false
                    })
            },

            update: function(){
                let formErrors  = this.$v.form.$invalid

                if(formErrors === false){
                    this.showOverlay = true
                    let formBody = []

                    for (let prop in this.form) {
                        if(this.form[prop] !== null){
                            let encodedKey = encodeURIComponent(prop)

                            if(prop == 'grupo'){
                                var encodedValue = encodeURIComponent(this.form[prop].id)
                            }else{
                                var encodedValue = encodeURIComponent(this.form[prop])
                            }
                            
                            
                            formBody.push(encodedKey + "=" + encodedValue)
                        }
                    }

                    formBody = formBody.join("&")

                    fetch(server + 'crud/sub-grupo/' + this.id, {
                        method: 'PUT',
                        headers: new Headers({
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'token' : this.getToken
                        }),
                        body: formBody
                    })
                        .then(res => (res.json()))
                        .then(response => {
                            if(response.data){
                                this.alert = {
                                    type: 'success',
                                    message: 'Sub Grupo Editado',
                                    show: true
                                }
                            }else{
                                this.alert = {
                                    type: 'warning',
                                    message: response.message,
                                    show: true
                                }
                            }
                        })
                        .catch(error => {
                            this.alert = {
                                type: 'danger',
                                message: 'Erro ao editar',
                                show: true
                            }
                        })
                        .finally(() => {
                            this.showOverlay = false
                        })
                }else{
                    this.alert = {
                        type: 'warning',
                        message: 'Existem campos inválidos',
                        show: true
                    }
                }
            },
            closeAlert: function(){
                this.alert = {
                    type: 'alert-warning',
                    message: '',
                    show: false
                }
            },

            clear: function(){
                for(let prop in this.form){
                    this.form[prop] = null
                }
            }
        },

        mounted(){
            this.buscarGrupos()
            this.buscarDados()
        }
    }
</script>